import { Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { Currency, FixedProductInput, UsageProductInput } from '@vy/types';
import { isEmptyArray, isNotEmptyArray } from '@vy/utils';
import React from 'react';
import { AddIcon } from '../../../../../../../components/icons/AddIcon';
import { MeteredCreditsChargesEditTable } from '../../../MeteredCreditsChargesEditTable/MeteredCreditsChargesEditTable';
import { PromotionChargesEditTable } from '../../../PromotionChargesEditTable/PromotionChargesEditTable';
import { AddItemMenuButton } from '../../create-plan-page-tabs-components/AddItemMenuButton';
import { EmptyTab } from '../../create-plan-page-tabs-components/EmptyTab';
import { PromotionsChargesMenuItems } from './promotion-charges-tab-content-components/PromotionsChargesMenuItems';

type PromotionChargesTabContentProps = {
  promotions: FixedProductInput[];
  meteredCredits: UsageProductInput[];
  currency: Currency;
};

export const PromotionChargesTabContent: React.FC<PromotionChargesTabContentProps> = ({
  promotions,
  meteredCredits,
}) => {
  if (isEmptyArray(promotions) && isEmptyArray(meteredCredits)) {
    return (
      <EmptyTab
        title="Credits & Discounts"
        description={
          <p>
            <span>Add credits and discounts to match</span>
            <br />
            <span> your customers terms.</span>
          </p>
        }
      >
        <AddItemMenuButton
          cta={
            <span className="flex items-center gap-x-2">
              <AddIcon fill="white" />
              <span>Add Promotions</span>
            </span>
          }
        >
          <PromotionsChargesMenuItems />
        </AddItemMenuButton>
      </EmptyTab>
    );
  }

  return (
    <div className="flex w-full flex-col gap-y-4">
      <div className="flex items-center justify-between">
        <Typography variant="h6">Promotions</Typography>

        <AddItemMenuButton
          color="secondary"
          cta={
            <span className="flex items-center gap-x-2">
              <VyIcon
                icon="PlusMedium"
                style={{
                  transform: 'scale(0.8)',
                }}
              />
              <span>Add Item</span>
            </span>
          }
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <PromotionsChargesMenuItems />
        </AddItemMenuButton>
      </div>

      {isNotEmptyArray(promotions) && <PromotionChargesEditTable promotions={promotions} />}

      {isNotEmptyArray(meteredCredits) && <MeteredCreditsChargesEditTable meteredCredits={meteredCredits} />}
    </div>
  );
};
